<template>
  <sys-user-table
    client-type="app"
    title="User List"
    create-text="New User"
    entity-name="user"
  />
</template>

<script>
import SysUserTable from '@/views/system/components/SysUserTable.vue'

export default {
  name: 'SystemUserListCompat',
  components: { SysUserTable }
}
</script>
